import { Text, TextTypography } from '../Text/Text';
import { TextAreaControl } from '../TextAreaControl/TextAreaControl';
import { ColorButton } from './ColorButton';
import { HorizontalAlignmentButton } from './HorizontalAlignmentButton';
import { VerticalAlignmentButton } from './VerticalAlignmentButton';
import { COLORS } from './colors';
import { HorizontalAlignment, VerticalAlignment } from './types';
import { Box } from '@material-ui/core';
import React, { ChangeEvent, useCallback } from 'react';
import i18n from '../../../i18n';

export interface GalleryDialogBannerSettingsProps {
    bannerText: string;
    onBannerTextChange: (value: string) => void;
    horizontalAlignment: HorizontalAlignment;
    onHorizontalAlignmentChange: (value: HorizontalAlignment) => void;
    verticalAlignment: VerticalAlignment;
    onVerticalAlignmentChange: (value: VerticalAlignment) => void;
    color: string;
    onColorChange: (value: string) => void;
}

const MAX_CHARS = 80;

export const GalleryDialogBannerSettings = (props: GalleryDialogBannerSettingsProps) => {
    const { onBannerTextChange } = props;
    const { t } = i18n.useTranslation();

    const handleBannerTextChange = useCallback(
        (event: ChangeEvent<HTMLTextAreaElement>) => {
            const { value } = event.target;
            if (value.length <= MAX_CHARS) {
                onBannerTextChange(value);
            }
        },
        [onBannerTextChange],
    );

    return (
        <Box display="flex" p={2}>
            <Box flex="1" mr={4}>
                <Text typography={TextTypography.BODY_ACCENT}>{t('common:gallery.bannerText')}</Text>
                <TextAreaControl label="" value={props.bannerText} onChange={handleBannerTextChange} />
                <Text typography={TextTypography.CAPTION}>
                    {props.bannerText.length}/{MAX_CHARS} {t('common:gallery.symbol')}
                </Text>
            </Box>
            <Box flex="0 0 auto">
                <Box display="flex" my={1}>
                    {COLORS.map(color => (
                        <Box key={color} mr={1}>
                            <ColorButton color={color} onSelect={props.onColorChange} />
                        </Box>
                    ))}
                </Box>
                <Box display="flex" my={1}>
                    {Object.values(HorizontalAlignment).map(alignment => (
                        <Box key={alignment} mr={1}>
                            <HorizontalAlignmentButton
                                alignment={alignment}
                                isSelected={props.horizontalAlignment === alignment}
                                onSelect={props.onHorizontalAlignmentChange}
                            />
                        </Box>
                    ))}
                </Box>
                <Box display="flex" my={1}>
                    {Object.values(VerticalAlignment).map(alignment => (
                        <Box key={alignment} mr={1}>
                            <VerticalAlignmentButton
                                alignment={alignment}
                                isSelected={props.verticalAlignment === alignment}
                                onSelect={props.onVerticalAlignmentChange}
                            />
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
};
